export type SortDirection = "ascending" | "descending" | "none";

export function sortableHeaderProps(direction: SortDirection): {
  readonly "aria-sort": SortDirection;
} {
  return { "aria-sort": direction };
}

export function expanderButtonProps(
  expanded: boolean,
  controls: string,
): { readonly "aria-controls": string; readonly "aria-expanded": boolean } {
  return { "aria-controls": controls, "aria-expanded": expanded };
}

export function noDataProps(): { readonly "aria-label": "no data" } {
  return { "aria-label": "no data" };
}

function isFocusCandidate(element: HTMLElement | null): element is HTMLElement {
  return element !== null
    && element.isConnected
    && !element.matches(":disabled, [aria-disabled='true']")
    && element.closest("[hidden], [inert]") === null;
}

export function restoreFocus(
  preferred: HTMLElement | null,
  fallback: HTMLElement | null,
): void {
  for (const candidate of [preferred, fallback]) {
    if (!isFocusCandidate(candidate)) continue;
    candidate.focus();
    if (document.activeElement === candidate) return;
  }
}

export function returnFocus(element: HTMLElement | null): void {
  restoreFocus(element, null);
}
